function assert (condition, message) {
  if (!condition) {
    throw new Error(`[vue-local-storage] ${message}`)
  }
}

export class VueLocalStorage {
  getItem (key) {
    return window.localStorage.getItem(key)
  }
  setItem (key, value) {
    return window.localStorage.setItem(key, value)
  }
  removeItem (key) {
    return window.localStorage.removeItem(key)
  }
  clear () {
    return window.localStorage.clear()
  }

  /* eslint-disable-next-line no-unused-vars */
  init (app /* Vue component instance */) {
    process.env.NODE_ENV !== 'production' && assert(
        install.installed,
        `not installed. Make sure to call \`Vue.use(VueLocalStorage)\` ` +
        `before creating root instance.`
    )
  }
}

function install (Vue) {
  Vue.mixin({
    beforeCreate () {
      if (this.$options.localStorage instanceof VueLocalStorage) {
        this._localStorageRoot = this
        this._localStorage = this.$options.localStorage
        this._localStorage.init(this)
      } else {
        this._localStorageRoot = (this.$parent && this.$parent._localStorageRoot) || this
      }
    },
    destroyed () {}
  })
  Object.defineProperty(Vue.prototype, '$localStorage', {
    get () { return this._localStorageRoot._localStorage }
  })
  install.installed = true
}
install.installed = false

// the static install method Vue is searching for on installation
VueLocalStorage.install = install
